import { LEVEL_ERROR, LEVEL_SUCCESS } from "constant/messages";

const ADD_MESSAGE = "message::add";
const CLEAR_MESSAGES = "message::clear-all";
const CLEAR_MESSAGES_BY_SOURCE = "message::clear-by-source";

// eslint-disable-next-line max-params
function addMessageAction(
  level,
  message,
  source = "",
  statusCode = null,
  created = null,
) {
  if (!created) {
    created = Date.now();
  }

  const payload = { level, message, source, statusCode, created };
  return {
    payload,
    type: ADD_MESSAGE,
  };
}

function addErrorMessageAction(...args) {
  return addMessageAction(LEVEL_ERROR, ...args);
}

function addSuccessMessageAction(...args) {
  return addMessageAction(LEVEL_SUCCESS, ...args);
}

function clearMessagesBySourceAction(source) {
  return {
    payload: { source },
    type: CLEAR_MESSAGES_BY_SOURCE,
  };
}

const clearMessagesAction = {
  type: CLEAR_MESSAGES,
};

export {
  ADD_MESSAGE,
  addErrorMessageAction,
  addMessageAction,
  addSuccessMessageAction,
  CLEAR_MESSAGES,
  CLEAR_MESSAGES_BY_SOURCE,
  clearMessagesAction,
  clearMessagesBySourceAction,
};
